import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import Modal from 'react-awesome-modal'
import Countdown, { zeroPad } from 'react-countdown-now'
import OnBoardingRedirect from './OnBoardingRedirect'
import Timeout from './Timeout'

class SecondFactoAuthentication extends Component {
  constructor (props) {
    super(props)
    this.state = {
      couldSendToken: true,
      secondFactorAuthConfirmated: false,
      timeUp: false,
      token: '',
      initialDate: Date.now(),
      key: 1,
      resend: true,
      timerCompleted: false,
      tryCounter: 1,
      countdownDate: Date.now() + 120000,
      restartCountdown: false
    }
  }

  getConfirmedOrderId = () => {
    return this.props.sendTwoFactorAuthorization &&
      this.props.sendTwoFactorAuthorization.enable
      ? this.props.sendTwoFactorAuthorization.orderId
      : this.props.confirmedOrderId
  }

  enableSendButton = event => {
    this.setState({
      couldSendToken: event.target.value.length > 0,
      token: event.target.value
    })
  }

  sendSMS = () => {
    if (
      this.props.sendTwoFactorAuthorization &&
      this.props.sendTwoFactorAuthorization.enable
    ) {
      this.props.authorizeWithTokenMileage(
        this.props.sendTwoFactorAuthorization.orderId,
        this.state.token,
        this.props.sendTwoFactorAuthorization.orderMileageId,
        this.props.vendorId,
        this.state.tryCounter >= 3
      )
    } else {
      this.props.authorizeWithToken(
        this.getConfirmedOrderId(),
        this.props.paymentSelected === 'POINTS_ONLY'
          ? null
          : this.PaymentMoneyRequest(), // dadosdecartao
        this.state.token,
        1,
        false,
        this.state.tryCounter > 3
      )
    }
    this.setState({ tryCounter: Math.min(this.state.tryCounter + 1, 3), token: '' })
  }

  resendSMS = () => {
    this.setState({
      couldSendToken: false
    })

    this.props.authorizeWithTokenResend(
      this.getConfirmedOrderId(),
      this.props.paymentSelected === 'POINTS_ONLY'
        ? null
        : this.PaymentMoneyRequest(),
      this.state.token,
      1,
      true
    )

    this.setState({
      resend: true,
      timeUp: false,
      timerCompleted: false,
      key: this.state.key + 1,
      initialDate: Date.now(),
      couldSendToken: true,
      token: '',
      restartCountdown: true,
      countdownDate: null
    })
  }

  closeModal = () => {
    this.props.closeModal()
  }

  sendCall = () => {
    this.props.authorizeWithTokenResend(
      this.getConfirmedOrderId(),
      this.props.paymentSelected === 'POINTS_ONLY'
        ? null
        : this.PaymentMoneyRequest(),
      this.state.token,
      2,
      true
    )
    this.setState({
      resend: true,
      timeUp: false,
      timerCompleted: false,
      key: this.state.key + 1,
      initialDate: Date.now(),
      couldSendToken: false,
      restartCountdown: true,
      countdownDate: null
    })
  }

  PurchasePointsRequest = () => {
    return {
      CardBrandId: this.props.cardBrand(),
      CardExpirationMonthDate: this.props.creditCard.cardExpirationDateMonth,
      CardExpirationYearDate: this.props.creditCard.cardExpirationDateYear,
      CardNumber: this.props.creditCard.cardNumber,
      CardHolderCpfCnpj: this.props.creditCard.cardHolderCpf,
      CatalogId: this.props.catalog.id,
      NameOfCardHolder: this.props.creditCard.cardHolderName,
      Parcels: this.props.creditCard.installments,
      PointsCash: this.props.paymentPoints,
      SecurityCode: this.props.creditCard.cardCvv
    }
  }

  PurchaseMoneyRequest = () => {
    const brand = this.props.cardBrand()
    const validityDateParts = this.props.creditCard.validityDate.split('/')
    const totalOrder = this.props.payment.pointsCashConfig.totalOrder
    const installment =
      this.props.creditCard.installment ||
      this.props.payment.installments.items[2]
    const pointsCash = this.props.onlyCash
      ? installment.parcel * installment.parcelValue
      : totalOrder - this.props.paymentPoints

    return {
      CardBrandId: brand.id,
      CardExpirationMonthDate: validityDateParts[0],
      CardExpirationYearDate: validityDateParts[1],
      CardNumber: this.props.creditCard.number.replace(/\s/g, ''),
      CardHolderCpfCnpj: this.props.participant.cpf.value,
      CatalogId: this.props.catalog.id,
      NameOfCardHolder: this.props.creditCard.personName,
      Parcels: installment.parcel,
      PointsCash: pointsCash,
      SecurityCode: this.props.creditCard.cvv
    }
  }

  PaymentMoneyRequest = () => {
    switch (this.props.paymentSelected) {
      case 'PURCHASE_POINTS_ONLY':
        return this.PurchasePointsRequest()

      default:
        return this.PurchaseMoneyRequest()
    }
  }

  completionist = () => {
    setTimeout(() => {
      this.setState({
        timeUp: true,
        timerCompleted: true,
        secondFactorAuthConfirmated: null
      })
    }, 1000)

    if (this.state.tryCounter > 3) {
      this.props.closeModal()
    }

    return <span>O c&oacute;digo gerado expira em 00:00</span>
  }

  renderer = ({ minutes, seconds, completed }) => {
    if (completed && !this.props.loadingResendToken && this.state.countdownDate !== null) {
      return this.completionist()
    } else {
      return (
        <div>
          O c&oacute;digo gerado expira em {zeroPad(minutes, 2)}:{zeroPad(seconds, 2)}
        </div>
      )
    }
  }

  componentDidUpdate (prevProps) {
  }

  render () {
    return (
      <Modal
        width='580'
        height='0'
        effect='fadeInUp'
        visible={this.props.show}
      >
        <Fragment>
          <div
            className={`col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto pos-absolute ${this.props.secondFactorAuthConfirmated ? '' : 'd-none'
            }`}
            style={{
              top: '-243px'
            }}
          >
            <div className='row px-3 border-color-ui-3 border-bottom pb-2'>
              <div className='col-11'>
                <h3 id='modalTitle'>
                  Valide seu Token - Tentativa {this.state.tryCounter} de 3
                </h3>
              </div>
              <div className='col-1 text-right' />
            </div>
            <div className='col-12'>
              <div className='row'>
                <div className='col-12 mt-3'>
                  <div
                    className={`row mx-1 ${(this.state.timeUp && this.state.resend) ||
                        this.props.errorResend
                      ? 'd-none'
                      : ''
                    }`}
                  >
                    <div className='col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'>
                      <p className='col-12 txt-body-sm pb-2 px-0'>
                        Enviamos um código de 6 dígitos via SMS para o n&uacute;mero:<strong> {this.props.phone}</strong>
                        <br />
                        <strong> {this.props.phone}</strong>
                        <br />
                        <br />
                        {process.env.REACT_APP_URL_CHANGE_PHONE ? (<a href={process.env.REACT_APP_URL_CHANGE_PHONE} className='color-links border-color-links'>Trocar o meu n&uacute;mero</a>) : ''}
                        <br />
                        <br />
                        <hr />
                        <br />
                        Por favor, digite o c&oacute;digo no campo abaixo.
                      </p>
                      {this.props.errorToken && (
                        <p className='col-12 txt-body-sm pb-2 px-0 color-error'>
                          Token inv&aacute;lido, por favor tente novamente.
                        </p>
                      )}
                      {this.props.errorResend && (
                        <p className='col-12 txt-body-sm pb-2 px-0 color-ui-2 color-error'>
                          N&atilde;o foi poss&iacute;vel renviar, por favor tente novamente.
                        </p>
                      )}
                      <Input
                        id='txt-sms-confirmation'
                        label='Código de verificação'
                        className='form-field col-12 col-md-6 px-0'
                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                        value={this.state.token}
                        onChange={this.enableSendButton}
                        disabled={
                          this.props.isCreatingPurchase ||
                          this.props.loadingResendToken
                        }
                      />
                      <div className='col-12 col-md-6 row'>
                        <Button
                          id={'btn-send-sms-verification'}
                          name={'btn-send-sms-verification'}
                          className='btn btn-double btn-featured btn-rating-modal2 col-12 ml-0 ml-md-3'
                          text='Enviar'
                          loading={
                            this.props.isCreatingPurchase ||
                            this.props.loadingResendToken
                          }
                          disabled={!this.state.couldSendToken}
                          onClick={() => this.sendSMS()}
                        />
                      </div>
                    </div>
                    <div className='col-12 px-0 confirmation-alert py-2 pl-1'>
                      <div className='bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-2 px-2'>
                        <div className='row align-items-center h-100'>
                          <div className='col-auto'>
                            <i className='icon icon_clock color-brand-1' />
                          </div>
                          {this.props.isCreatingPurchase ? (
                            <div className='col col-md-10'>
                              <h2
                                id='countDownText'
                                className='color-brand-1 txt-circular-book txt-body-lg'
                              >
                                <div>Estamos validando a sua tentativa !</div>
                              </h2>
                            </div>
                          ) : (
                            <div className='col col-md-10'>
                              <h2
                                id='countDownText'
                                className='color-brand-1 txt-circular-book txt-body-lg'
                              >
                                {this.state.countdownDate === null || this.state.countdownDate < Date.now() || this.props.loadingResendToken ? (
                                  <div>O c&oacute;digo gerado expira em 02:00</div>
                                ) : (
                                  <Countdown
                                    autoStart
                                    key={this.state.key}
                                    date={this.state.countdownDate}
                                    renderer={this.renderer}
                                  />
                                )}
                              </h2>
                            </div>
                          )}
                          <div className='col-auto d-none' />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`row mx-1 ${this.state.timeUp || this.props.errorResend
                      ? ''
                      : 'd-none'
                    }`}
                  >
                    <div className='col-12 row color-ui-2 txt-font-body txt-body-sm product-rating mx-0'>
                      <p className='col-12 txt-body-sm pb-1 px-0'>
                        Enviamos um C&oacute;digo de 6 d&iacute;gitos via SMS para o n&uacute;mero:
                        <br />
                        <strong> {this.props.phone}</strong>
                        <br />
                        Mas o tempo limite para valida&ccedil;&atilde;o do c&oacute;digo expirou.
                      </p>
                      {this.props.errorResend && (
                        <p className='col-12 txt-body-sm pb-2 px-0 color-error'>
                          N&atilde;o foi poss&iacute;vel renviar, por favor tente novamente.
                        </p>
                      )}
                      <div className='col-12 row mx-0 px-0'>
                        <Button
                          className='btn btn-featured btn-sm btn-cart btn-icon col-12 col-md-6'
                          text='Reenviar SMS'
                          iconName='icon_message'
                          onClick={() => this.resendSMS()}
                        />
                        <Button
                          className='btn btn-featured btn-sm btn-cart btn-icon col-12 col-md-6 l-1'
                          text='Receber Ligação'
                          iconName='icon_call'
                          onClick={() => this.sendCall()}
                        />
                      </div>
                    </div>
                    {!this.props.errorResend && <Timeout />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!this.props.secondFactorAuthConfirmated && <OnBoardingRedirect oidc={this.props.oidc} showOnboarding={this.props.show} />}
        </Fragment>
      </Modal>
    )
  }
}

SecondFactoAuthentication.propTypes = {
  show: PropTypes.bool,
  isCreatingPurchase: PropTypes.bool,
  confirmedOrderId: PropTypes.number,
  vendorId: PropTypes.number,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  secondFactorAuthConfirmated: PropTypes.bool,
  phone: PropTypes.string,
  closeModal: PropTypes.func,
  errorToken: PropTypes.bool,
  errorResend: PropTypes.bool,
  sendTwoFactorAuthorization: PropTypes.object,
  creditCard: PropTypes.object,
  catalog: PropTypes.object,
  paymentSelected: PropTypes.string.isRequired,
  participant: PropTypes.object,
  cardBrand: PropTypes.func,
  onlyCash: PropTypes.bool,
  payment: PropTypes.object,
  paymentPoints: PropTypes.number,
  loadingResendToken: PropTypes.bool,
  oidc: PropTypes.object
}

export default SecondFactoAuthentication



// WEBPACK FOOTER //
// ./src/features/Checkout/SecondFactorAuthenticaton/SecondFactorAuthentication.js